
import { ReactNode } from "react";
import { getEventName, getLocationName } from "@/utils/tripFormatUtils";

interface TripCardHeaderProps {
  community_event?: any;
  to_address?: any;
  isCompleted: boolean;
  icon?: ReactNode;
}

const TripCardHeader = ({ 
  community_event, 
  to_address, 
  isCompleted,
  icon = "🎵"
}: TripCardHeaderProps) => {
  const location = getLocationName(to_address, community_event);
  const eventName = getEventName(community_event);
  
  return (
    <div className="flex items-center gap-2 mb-4">
      <div className={`h-6 w-6 ${isCompleted ? 'bg-white text-black' : 'bg-black text-white'} rounded-full flex items-center justify-center`}>
        <span className="text-xs">{icon}</span>
      </div>
      <span className={`${isCompleted ? 'text-white' : 'text-black'} font-medium`}>
        {eventName} {location}
      </span>
    </div>
  );
};

export default TripCardHeader;
